import type { IExpense } from './Expense.interface';
import ExpensePersonal from './ExpensePersonal';
import ExpenseProperty from './ExpenseProperty';
import ExpenseTransportation from './ExpenseTransportation';

export default class Expense implements IExpense {
  personal: ExpensePersonal;
  property: ExpenseTransportation;
  transportation: ExpenseProperty;

  static build = (data: IExpense) => new Expense(data);
  static blank = () => new Expense();

  /**
   * Constructor
   * @param {IExpense} data
   */
  constructor(data?: IExpense) {
    this.personal = new ExpensePersonal(data?.personal);
    this.property = new ExpenseProperty(data?.property);
    this.transportation = new ExpenseTransportation(data?.transportation);
  }
}
